import { generateQueryClient } from 'api/queryClient';
import React, { useMemo } from 'react';
import { QueryClientProvider } from 'react-query';
import { useErrorCtx } from 'state/error/ErrorCtx';

interface IAppQueryClientProviderProps {
	children: React.ReactNode;
	clientOptions?: Parameters<typeof generateQueryClient>[0];
}

const AppQueryClientProvider: React.FC<IAppQueryClientProviderProps> = ({
	children,
	clientOptions = {}
}) => {
	const { setError } = useErrorCtx();

	const queryClient = useMemo(
		() => generateQueryClient({ onError: setError, ...clientOptions }),
		[setError, clientOptions]
	);

	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	);
};

export default AppQueryClientProvider;
